import WagtailBlocksSection from '@global/Blocks/WagtailBlocksSection'

const SellingPage = ({ pageData }) => {
  return <WagtailBlocksSection blocks={pageData.content_blocks} />
}

export default SellingPage
